import { AppThunk } from '../../../store/rootReducer';
import * as episodeMeasurementActions from '../actions/episode-measurement.actions';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import {
  episodeMeasurementRangeSelector,
  episodeMeasurementUpdateModeSelector,
} from '../selectors/episode-measurement.selectors';

export const initializeEpisodeMeasurement =
  (): AppThunk => async (dispatch, getState) => {
    const [start, end] = episodeMeasurementRangeSelector(getState());
    const updateMode = episodeMeasurementUpdateModeSelector(getState());
    if (updateMode != null || start !== 0 || end !== 0) {
      return;
    }
    const ecgDuration = roundedDurationSelector(getState());
    const initialWidth = ecgDuration * 0.2;
    const newStart = ecgDuration / 2 - initialWidth / 2;
    const newEnd = newStart + initialWidth;

    dispatch(
      episodeMeasurementActions.setRange({
        start: newStart,
        end: newEnd,
        meta: { history: false },
      }),
    );
  };
